export interface IClientTitleData {
  effectiveDate?: string;
  vestingInfo?: string;
  legalDescription?: string;
  apn?: string;
  numOfOpenMortgages?: number;
  numOfBankruptcies?: number;
  numOfJudgements?: number;
  numOfOtherLiens?: number;
  requirements?: ILenderTitleRequirementsData[];
  exceptions?: ILenderTitleExceptionsData[];
  curativeGrade?: string;
}
export interface IClientTitleResponse {
  effective_date?: string;
  vesting_info?: string;
  legal_description?: string;
  apn?: string;
  num_of_open_mortgages?: number;
  num_of_bankruptcies?: number;
  num_of_judgements?: number;
  num_of_other_liens?: number;
  requirements?: ILenderTitleRequirementsData[];
  exceptions?: ILenderTitleExceptionsData[];
  curative_grade?: string;
}

export interface ILenderTitleRequirementsData {
  schedule: string;
  body: string;
  position: number;
}

export interface ILenderTitleExceptionsData {
  schedule: string;
  body: string;
  position: number;
}

export const convertFromClientTitleResponseToClientTitleData = (data: IClientTitleResponse): IClientTitleData => ({
  effectiveDate: data.effective_date,
  vestingInfo: data.vesting_info,
  legalDescription: data.legal_description,
  apn: data.apn,
  numOfOpenMortgages: data.num_of_open_mortgages,
  numOfBankruptcies: data.num_of_bankruptcies,
  numOfJudgements: data.num_of_judgements,
  numOfOtherLiens: data.num_of_other_liens,
  requirements: data.requirements,
  exceptions: data.exceptions,
  curativeGrade: data.curative_grade,
});
